import {
  EndOfJourneyAnswerInput,
  EndOfJourneyQuestionnaire
} from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function upsertEnrollmentEndOfJourneyQuestionnaire(input: {
  enrollmentId: number
  answers: EndOfJourneyAnswerInput[]
}) {
  return restApiClient
    .url(
      constructApiUrl(API['end-of-journey-questionnaires'].upsert.url, { id: input.enrollmentId })
    )
    .put<EndOfJourneyQuestionnaire>({ answers: input.answers })
}
